import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import {Http, Response, Headers, RequestOptions, URLSearchParams} from "@angular/http";
import { AuthHttp } from 'angular2-jwt';
// import { Auth } from './auth.service';
import { Router } from '@angular/router';
// import {  } from './auth.module';
import 'rxjs/add/operator/toPromise';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { retry } from 'rxjs/operators';


@Injectable()
export class Fmt {

    constructor(public _http: Http
                // , private auth: Auth
                , private authHttp: AuthHttp
                , private httpClient: HttpClient
                , private _router: Router) {
    }

    log(str: any) {
        console.log(str)
    }

    DefaultOptions(): RequestOptions {
        let options = new RequestOptions({ ...this.DefaultHeaders() });
        return options;
    }

    DefaultGetOptions(params: any): RequestOptions {
        let headers = this.DefaultHeaders();
        let options = new RequestOptions({ ...headers, body: {}, url: '', search: params });
        return options
    }

    DefaultHeaders(): HttpHeaders {
        // let headers = new HttpHeaders();
        // headers.append('Content-Type', 'application/json; charset=UTF-8');
        // headers.append('Authorization', 'Bearer ' + "1111");
        const httpOptions =  new HttpHeaders({
              'Content-Type':  'application/json',
              Authorization: "Bearer " + localStorage.getItem("token")
            })
        return httpOptions;
    }

    HttpGet<T>(apiPath: string, params?: any, retryCount: number = 3): Observable<T> {
        let options = this.DefaultGetOptions(params);
        return this.httpClient.get<T>(apiPath, { headers: this.DefaultHeaders(), params: params }).pipe(
            retry(retryCount)
        );
    }

    HttpPost<T>(apiPath: string, body?: any, retryCount: number = 3): Observable<T> {
        let options = this.DefaultOptions();
        return this.httpClient.post<T>(apiPath, body, {
            headers: this.DefaultHeaders()
        }).pipe(
            retry(retryCount)
        );
    }

    stringifyObj(params: any): any {
        return JSON.stringify(params)
    }

    moveToPath(path: string) {
        this._router.navigateByUrl(path);
    }

    stringsToJoin(paths: any[]): string {
        return paths.join("/")
    }

    toCurrency(curr: number): string {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'JPY',
            minimumFractionDigits: 2,
        });

        return formatter.format(curr)
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    objectKeys(object: any): string[] {
        if(!object) return [];
        return Object.keys(object);
    }
}
